// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__lah0k","ssr-layout":"styles_ssr-layout__qZXi2","breadcrumbContainer":"styles_breadcrumbContainer__GroES"};